module.exports = __webpack_public_path__ + "static/wimpole-454af06308b47839bc2da124bf64462a.jpg";